import { useParams } from 'react-router-dom';
import axios from 'axios';
import React, { useState, useEffect, forwardRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Paper, Card, CardContent, TextField, Button } from '@material-ui/core';
import ReactHtmlParser from 'html-react-parser';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Cookies from 'universal-cookie';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useHistory } from 'react-router';
import './Learn.css';
const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
const useStyles = makeStyles(theme => ({
    mainFeaturedPost: {
        position: 'relative',
        backgroundColor: theme.palette.grey[800],
        color: theme.palette.common.white,
        marginBottom: theme.spacing(4),
        marginTop: '11vh',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        height: '250px',
    },
    overlay: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        backgroundColor: 'rgba(0,0,0,.3)',
    },
    mainFeaturedPostContent: {
        position: 'relative',
        padding: theme.spacing(10),
    },
    contentPost: {
        margin: theme.spacing(10),
        padding: theme.spacing(3),
        wordWrap: 'break-word',

    }
}
));


export default function Learn2(props) {
    const cookies = new Cookies();
const userToken = cookies.get('tokenCTF');
    const [openSuccess, setOpenSuccess] = useState(false);
    const [openError, setOpenError] = useState(false);
    const [error, setErrorMessage] = useState('');
    const [success, setSuccessMessage] = useState('');
    const { content_id } = useParams();
    const classes = useStyles();
    const [learnHead, setLearnHead] = useState([]);
    const [flags, setFlags] = useState([]);
    const [showFlags, setShowFlags] = useState(false);
    const [answer, setAnswer] = useState('');
    const history = useHistory();
    const handleClose = () => {
        setOpenError(false);
        setOpenSuccess(false);
    };
    useEffect(() => {
        axios.post(`https://${process.env.REACT_APP_BASE_URL}/api/learning/getLearnID`, { learn_id: content_id }, {
            headers: { 'Authorization': userToken }
        }).then((response) => {
            if (response) {
               
               
                    setLearnHead(response.data);
                
            }
        });
        axios.post(`https://${process.env.REACT_APP_BASE_URL}/api/learning/questions`, { learn_id: content_id }, {
            headers: { 'Authorization': userToken }
        }).then((response) => {
            if (response) {
               
                    if (response.data.messageError) {
                        setShowFlags(false);
                    }
                    else {
                        setFlags(response.data);
                        setShowFlags(true);
                    }
                
            }
        });

    }, []);
    const onSubmitFlag = (id) => {
        const idFlag = id;
        axios.post(`https://${process.env.REACT_APP_BASE_URL}/api/learning/checkFlag`, { flag_id: idFlag, flag: answer }, {
            headers: { 'Authorization': userToken }
        }).then((response) => {
            if (response) {


                if (response.data.messageSuccess) {
                    setSuccessMessage(response.data.messageSuccess);
                    setOpenSuccess(true);
                    setAnswer('')
                }
                else {
                    setErrorMessage(response.data.messageError);
                    setOpenError(true);
                    setAnswer('')
                }

            }
        });
    }
    return (
        <>
            {learnHead.map((value) => {
                return (
                    <>
                        <Paper className="mainFeaturedPost" >
                            <div className="overlay" />
                            <Grid container>
                                <Grid item md={6}>
                                    <div className="mainFeaturedPostContent">
                                        <Typography component="h1" variant="h3" color="inherit" gutterBottom>
                                            {value.title}
                                        </Typography>
                                    </div>
                                </Grid>
                            </Grid>
                        </Paper>
                        <Paper className="contentPost">
                            {ReactHtmlParser(value.content)}

                        </Paper>
                    </>
                )
            })}
            {showFlags ? flags.map((value) => {
                return (
                    <>
                        <Paper className="contentPost">
                            <Typography variant="h6" color="inherit" gutterBottom>
                                {value.question}
                            </Typography>
                            <TextField id="outlined-basic" label="Flag" variant="outlined" onChange={(e) => {
                                setAnswer(e.target.value);
                            }} className="textField" />
                            <br />
                            <div align="right">
                                <Button variant="contained" color="primary" onClick={(e) => { onSubmitFlag(value.flag_id) }}>Enviar</Button>
                            </div>
                        </Paper>
                    </>
                )
            })
                : ''
            }
            <Snackbar open={openError} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="error" sx={{ width: '100%', top: '0' }}>
                    {error}
                </Alert>
            </Snackbar>
            <Snackbar open={openSuccess} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="success" sx={{ width: '100%', top: '0' }}>
                    {success}
                </Alert>
            </Snackbar>
        </>
    );
}
